import type { LocalUiProvider, LocalUiProviderGrade } from './types';

/** RAVEN GRADE 1-10: launch checks passed, scaled to 10.
 *  10 = FLAWLESS (gold foil), 7-9 = CLEAR, <=6 = REVIEW, never checked = face-down. */
export function providerGrade(provider: LocalUiProvider): LocalUiProviderGrade {
  if (provider.state === 'not_detected' || provider.launchPath.length === 0) {
    return { value: null, tier: 'facedown', label: 'FACE DOWN' };
  }
  const total = provider.launchPath.length;
  const ready = provider.launchPath.filter((item) => item.state === 'ready').length;
  const value = Math.round((ready / total) * 10);
  if (value >= 10) {
    return { value: 10, tier: 'flawless', label: 'FLAWLESS 10' };
  }
  if (value >= 7) {
    return { value, tier: 'clear', label: `CLEAR ${value}` };
  }
  const fixes = total - ready;
  return { value, tier: 'review', label: `REVIEW ${value} · ${fixes} ${fixes === 1 ? 'FIX' : 'FIXES'}` };
}
